/**
 * The receipt strip under the byline: unroll and roll up, and each step's evidence (receipt v2,
 * variant E). Markup: `avoid_content_receipt_strip()` in inc/blog.php; styles:
 * assets/src/receipt.css.
 *
 * Enhancement only. Every line of the receipt is in the server HTML; this file toggles
 * `is-open` on the strip (the CSS unrolls the paper and makes it reachable), `aria-expanded` on
 * each button and `hidden` on each evidence panel. The button labels come from the markup's
 * `data-open` / `data-closed`, so no copy lives here.
 */

/**
 * Swap a label to its open or closed text.
 *
 * @param {?HTMLElement} el   The label element, or null.
 * @param {boolean}      open The new state.
 */
function setLabel( el, open ) {
	if ( el ) {
		el.textContent = open ? el.dataset.open : el.dataset.closed;
	}
}

/**
 * Wire one receipt.
 *
 * @param {HTMLElement} box The `[data-ac-receipt]` wrapper.
 */
function initReceipt( box ) {
	const toggle = box.querySelector( '[data-ac-rx-toggle]' );
	if ( ! toggle ) {
		return;
	}

	// The How we check specimen paints unrolled on a wide screen from CSS alone; here the toggle
	// takes that state over (and a phone keeps it rolled up), then the attribute goes so the CSS
	// no longer holds it open.
	if ( box.dataset.acRxOpen === 'wide' ) {
		const wide = window.matchMedia( '(min-width: 768px)' ).matches;
		toggle.setAttribute( 'aria-expanded', String( wide ) );
		box.classList.toggle( 'is-open', wide );
		setLabel( toggle.querySelector( '[data-ac-rx-label]' ), wide );
		delete box.dataset.acRxOpen;
	}

	toggle.addEventListener( 'click', () => {
		const open = toggle.getAttribute( 'aria-expanded' ) !== 'true';
		toggle.setAttribute( 'aria-expanded', String( open ) );
		box.classList.toggle( 'is-open', open );
		setLabel( toggle.querySelector( '[data-ac-rx-label]' ), open );
	} );

	box.querySelectorAll( '[data-ac-rx-step]' ).forEach( ( step ) => {
		const panel = document.getElementById(
			step.getAttribute( 'aria-controls' )
		);
		if ( ! panel ) {
			return;
		}
		step.addEventListener( 'click', () => {
			const open = step.getAttribute( 'aria-expanded' ) !== 'true';
			step.setAttribute( 'aria-expanded', String( open ) );
			panel.hidden = ! open;
			setLabel( step.querySelector( '[data-ac-rx-mark]' ), open );
		} );
	} );
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '[data-ac-receipt]' ).forEach( initReceipt );
} );
